export default async function GetInvestorPortfolio(investorId = null, ProjectId = null) {
    let url = window.RealestateService + `/api/PaymentDetails/GetProjectWiseInvestorPaymentDetails`;
    if (investorId === null) {
        url = url
    }
    else if(investorId){
        url = url+`?investorId=${investorId}`
    }
    if(ProjectId){
        url = url + `?projectId=${ProjectId}`
    }
    let head = {
        "content-type": "application/json",
        "accept": "*/*"
    }
    let response = await fetch(url, {
        method: "GET",
        headers: head,
    }).then(res => res.json()).catch(res => res)

    return response
}